import { useApi } from './use-api-call';

export const useSearchCustomerApi = () =>
    useApi<{
        customers: CustomerDTO[];
        allowEdit: boolean;
    }>('/customer/search-customer');

export const useGetCustomerApi = () =>
    useApi<{ customer: CustomerDTO; allowEdit: boolean }>('/customer/get-customer/{id}');

export const useSaveCustomerApi = () =>
    useApi<{ customer: CustomerDTO }>('/customer/save-customer');

export const useDeleteCustomerApi = () => useApi('/customer/delete-customer/{id}');

export interface CustomerDTO {
    id?: number;
    firstName: string;
    lastName: string;
    nationalCode?: string;
    nationalId?: string;
    phoneNumber?: string;
    companyName?: string;
    createdAt?: Date;
    createdBy?: string;
    modifiedAt?: Date;
    modifiedBy?: string;
}
